import {setDefaults} from "@/router/helper";

const DeclareProductForm = () => import('@/views/template/DeclareProductForm.vue');
const DeclareProductList = () => import('@/views/template/DeclareProductList.vue');

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);
// export default [
//   {
//
//     //报关品名模板
//     path: '/templateDeclareProductList',
//     component: DeclareProductList,
//   },
//   {
//     path: '/templateDeclareProductForm/:templateId',
//     component: DeclareProductForm,
//   },
//
// ];

const routes = [
  {
    path:'templateProcessPlanList',
    meta:{
      title:'生产工艺安排模板'
    },
    component: _import('template/processStepPlanList.vue')
  },
  {
    path:'templateProcessPlanForm/:id',
    meta:{
      title:'生产工艺安排模板'
    },
    component: _import('template/processStepPlanForm.vue')
  },
  {
    path: 'tradeDeclareTitle',
    meta: {
      title: '报关抬头',
    },
    component: _import('template/TradeDeclareTitle.vue')
  },
  {
    path: 'templateDeclareProductList',
    meta: {
      title: '报关要素',
    },
    component: _import('template/DeclareProductList.vue'),
  },
  {
    path: 'templateDeclareProductForm/:templateId',
    meta: {
      title: '报关信息模板',
    },
    component: _import('template/DeclareProductForm.vue'),
  },
  {
    path: 'templateBillInvoiceTitle',
    meta: {
      title: '箱单发票',
    },
    component: _import('template/BillInvoiceTitleList.vue'),
  },
  {
    path: 'fabricAndAccessoryList',
    meta: {
      title: '面辅料模板',
    },
    component: _import('template/FabricAndAccessoryList.vue'),
  },
  {
    path: 'fabricAndAccessoryForm/',
    meta: {
      title: '面辅料模板详情',
    },
    component: _import('template/FabricAndAccessoryForm.vue'),
  },
  {
    path: 'templateBillInvoiceTitleForm/:templateId',
    meta: {
      title: '箱单发票模板',
    },
    component: _import('template/BillInvoiceTitleForm.vue'),
  },{
    path:'admin',
    component: _import('admin/adminIndex.vue'),
    // redirect:{path:'admin/contractTemplateList'}
  },
  {
    path:'admin/contractTemplateList',
    meta: {
      title: '合同模板列表',
    },
    component: _import('admin/contractTemplateList.vue'),
  },
  {
    path:'admin/nevesContract/:templateId',
    meta: {
      title: '模板信息',
    },
    component: _import('admin/contractTemplate.vue'),
  },{
    path:'admin/scannerList',
    meta: {
      title: '扫描设备',
    },
    component: _import('admin/scannerList.vue'),
  },
  {
    path:'admin/consumerCardList',
    meta: {
      title: '用户卡列表',
    },
    component: _import('admin/consumerCardList.vue'),
  },
  {
    path:'admin/consumerApplyList',
    meta: {
      title: '用户申请列表',
    },
    component: _import('admin/consumerApplyList.vue'),
  },{
    path: 'admin/spreaderList',
    component: _import('admin/spreaderList.vue'),
  },{
    path:'admin/tradewmstoken',
    meta:{
      title: 'wms系统对接'
    },
    component:  _import('wms/wmstoken.vue'),
  }


];


export default setDefaults(routes);
